import React from "react";
import { useParams } from "react-router-dom";
	import LoginHome from '../../auth/login_home_main.jsx';
import National_market from '../process/national_market.jsx';
import { Cookies } from '../../index.js';
import Post_content from '../../community/content/Blog_posts.jsx';

const ProfileUsers = () => {
    const { slug_1 } = useParams();
    const national_market = Cookies.get("national_market");

    return (
        <>
            <LoginHome />

            {!national_market && (
                <National_market />
            )}
            <div className='mt-1 mb-3' >
                <Post_content mode={'hust_media'} show_adsense={'NO'} show_adskeeper={'NO'} uri={'fast_signup'} />
            </div>
            <>

                <div className="min-h-screen text-gray-800 mx-4 flex justify-center items-start">
                    <div className="max-w-3xl w-full bg-white shadow-lg rounded-2xl p-5">
                        <h1 className="text-3xl font-bold mb-4 text-gray-900">User Data Security</h1>
                        <p className="text-base leading-relaxed mb-4">
                            We take the protection of your personal data seriously. Our platform is designed with multiple layers of security to ensure that your information remains protected at all times.
                        </p>


                        <div className="space-y-4">
                            <section>
                                <h2 className="text-xl font-semibold mb-2">🔒 Secure Storage</h2>
                                <p className="text-sm leading-relaxed">
                                    All user data is encrypted both in transit and at rest. We use industry‑standard encryption protocols to ensure that your personal information cannot be accessed by unauthorized parties.
                                </p>
                            </section>


                            <section>
                                <h2 className="text-xl font-semibold mb-2">🛡️ Access Control</h2>
                                <p className="text-sm leading-relaxed">
                                    Only authorized personnel with strict clearance levels can access sensitive data. All access attempts are logged and monitored to maintain full transparency.
                                </p>
                            </section>


                            <section>
                                <h2 className="text-xl font-semibold mb-2">📌 Data Minimization</h2>
                                <p className="text-sm leading-relaxed">
                                    We only collect the minimum information needed to operate our services. Anything unnecessary is never stored or processed.
                                </p>
                            </section>


                            <section>
                                <h2 className="text-xl font-semibold mb-2">🧩 Transparency</h2>
                                <p className="text-sm leading-relaxed">
                                    You have full control over your data. You may request access, updates, or deletion of your information at any time through your account settings.
                                </p>
                            </section>


                            <section>
                                <h2 className="text-xl font-semibold mb-2">🚨 Threat Monitoring</h2>
                                <p className="text-sm leading-relaxed">
                                    Our system continuously monitors for suspicious activities and potential security threats. Any detected risks are addressed immediately by our security team.
                                </p>
                            </section>
                        </div>


                        <footer className="mt-6 text-center text-xs text-gray-500">
                            © {new Date().getFullYear()} {window.location.hostname}. All rights reserved.
                        </footer>
                    </div>
                </div>
            </>
        </>
    );
};

export default ProfileUsers;
